// src/lib/api.js
import axios from 'axios';

// En dev el proxy de Vite redirige /api → http://localhost:4000/api (sin CORS).
// En prod (Railway) el frontend y backend comparten el mismo origin.
const baseURL = import.meta.env.VITE_API_URL || '/api';

export const api = axios.create({ baseURL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

function toErrorString(v) {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'object') {
    if (typeof v.message === 'string') return v.message;
    if (typeof v.error === 'string') return v.error;
    try { return JSON.stringify(v); } catch { return String(v); }
  }
  return String(v);
}

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Normalize err.response.data.error so setError(err.response?.data?.error || ...)
    // never puts an object into React state (causes "Objects are not valid as a React child").
    const d = err?.response?.data;
    if (d && typeof d === 'object') {
      if ('error' in d && typeof d.error !== 'string') d.error = toErrorString(d.error);
      if ('message' in d && typeof d.message !== 'string') d.message = toErrorString(d.message);
    } else if (d && typeof d !== 'string') {
      err.response.data = { error: toErrorString(d) };
    }
    if (err?.response?.status === 401) {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      } catch {}
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
